import React, { useState, useEffect, useContext } from 'react';
import { Buffer } from "buffer";
import Layout from '../../src/Components/Layout';
import Login from '../../src/Components/Login';
import Menu from '../../src/Components/Menu';
import Spinner from '../../src/Components/Utils/Spinner';

import { getCustomer, createCustomerPortalSession } from '../../src/Components/Helpers/Account';
import ErrorResponse from '../../src/Components/Utils/ErrorResponse';
import { AuthContext, ThemeContext } from '../App';

export default function PaymentMethods({}) {
    const auth = useContext(AuthContext);

    const [isLoading, setIsLoading] = useState(true);
    const [networkErr, setNetworkErr] = useState(false);

    useEffect(() => {
        console.log(auth)
        if (auth && auth.isAuthenticated && auth.user) {
            const accessToken = auth.user.signInUserSession.accessToken.jwtToken;
            const accessTokenExp = auth.user.signInUserSession.accessToken.payload.exp;
            const accessTokenExpTime = new Date(accessTokenExp * 1000).getTime();
            const idToken = auth.user.signInUserSession.idToken.jwtToken;
            const idTokenDecodedBuffer = Buffer.from(idToken.split('.')[1], 'base64').toString();
            const idTokenDecodedJSON = JSON.parse(idTokenDecodedBuffer);
            const customerID = idTokenDecodedJSON['custom:ns_customer_id'];

            if (accessTokenExpTime < new Date()) {
                location.reload();
                return false;
            }

            managePaymentMethods(accessToken, customerID);
        }
    }, [auth]);

    const managePaymentMethods = async (accessToken, customerID) => {
        setIsLoading(true);
        const returnURL = location.origin;

        return await getCustomer(accessToken, customerID)
        .then((result) => {
            const stripeData = {
                stripeCustomerId: result.customer.stripeCustomerId,
                stripeBillingCompany: result.customer.stripeBillingCompany,
            };
            return stripeData;
        })
        .then((result) => {
            console.log(result);
            createCustomerPortalSession(
                accessToken, 
                customerID, 
                result.stripeBillingCompany, 
                result.stripeCustomerId,
                returnURL
            ).then(res => {
                console.log(res);
                window.location.href = res.session.url
            })
            .catch(err => {
                console.log(err);
                setIsLoading(false);
            });
        })
        .catch(() => {
            setIsLoading(false);
            setNetworkErr(true);
        });
    }

    return (
        <>
            <Layout
                auth={auth}
                isLoading={isLoading}
                networkErr={networkErr}
            >
                {auth && auth.isAuthenticated && auth.user ? (
                    <>
                        <Menu cardsMenuActive={true} />
                        {isLoading ? (
                            <Spinner />
                        ) : (
                            <></>
                        )}
                        {networkErr && (
                            <ErrorResponse
                                setNetworkErr={setNetworkErr}
                                closeEvent="reload"
                            />
                        )}
                    </>
                ) : (
                    <Login />
                )}
            </Layout>
        </>
    );
}
